module.exports = __webpack_public_path__ + "static/media/Harmonizer Modeler Mid Gain VR.6ee319e.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/modeler/Harmonizer Modeler Mid Gain VR.mp3
// module id = U8xz
// module chunks = 12